import {
  UserProfileStoreModel,
  CompanyStoreModel,
  BalanceZoneStoreModel,
  UserStoreModel
} from '../store.model';
import { EnumCommodity } from '../../api';

export enum ProfileActionTypes {
  STORE_USER = 'STORE_USER',
  STORE_LOGOUT_HANDLER = 'STORE_LOGOUT_HANDLER',
  STORE_USER_PROFILE = 'STORE_USER_PROFILE',
  STORE_CUSTOMER_MENU = 'STORE_CUSTOMER_MENU',
  STORE_CUSTOMER_CONFIG = 'STORE_CUSTOMER_CONFIG',
  STORE_COMPANIES = 'STORE_COMPANIES',
  STORE_ACTIVE_COMPANY = 'STORE_ACTIVE_COMPANY',
  STORE_BALANCE_ZONES = 'STORE_BALANCE_ZONES',
  STORE_ACTIVE_BALANCE_ZONE = 'STORE_ACTIVE_BALANCE_ZONE',
  STORE_ACTIVE_COMMODITY = 'STORE_ACTIVE_COMMODITY'
}

export interface StoreUserAction {
  type: ProfileActionTypes;
  payload: UserStoreModel;
}

export interface StoreLogoutHandlerAction {
  type: ProfileActionTypes;
  payload: () => void;
}

export interface StoreUserProfileAction {
  type: ProfileActionTypes;
  payload: UserProfileStoreModel;
}

export interface StoreCompaniesAction {
  type: ProfileActionTypes;
  payload: CompanyStoreModel[];
}

export interface StoreActiveCompanyAction {
  type: ProfileActionTypes;
  payload: number;
}

export interface StoreBalanceZonesAction {
  type: ProfileActionTypes;
  payload: BalanceZoneStoreModel[];
}

export interface StoreActiveBalanceZoneAction {
  type: ProfileActionTypes;
  payload: number;
}

export interface StoreActiveCommodityAction {
  type: ProfileActionTypes;
  payload: EnumCommodity | undefined;
}

export const storeUserAction = (user: UserStoreModel): StoreUserAction => {
  return { type: ProfileActionTypes.STORE_USER, payload: user };
};

export const storeLogoutHandlerAction = (logoutHandler: () => void): StoreLogoutHandlerAction => {
  return { type: ProfileActionTypes.STORE_LOGOUT_HANDLER, payload: logoutHandler };
};

export const storeUserProfileAction = (
  userProfile: UserProfileStoreModel
): StoreUserProfileAction => {
  return { type: ProfileActionTypes.STORE_USER_PROFILE, payload: userProfile };
};

export const storeCompaniesAction = (companies: CompanyStoreModel[]): StoreCompaniesAction => {
  return { type: ProfileActionTypes.STORE_COMPANIES, payload: companies };
};

export const storeActiveCompanyAction = (id: number): StoreActiveCompanyAction => {
  return { type: ProfileActionTypes.STORE_ACTIVE_COMPANY, payload: id };
};

export const storeBalanceZonesAction = (
  balanceZones: BalanceZoneStoreModel[]
): StoreBalanceZonesAction => {
  return { type: ProfileActionTypes.STORE_BALANCE_ZONES, payload: balanceZones };
};

export const storeActiveBalanceZoneAction = (id: number): StoreActiveBalanceZoneAction => {
  return { type: ProfileActionTypes.STORE_ACTIVE_BALANCE_ZONE, payload: id };
};

export const storeActiveCommodityAction = (
  commodity: EnumCommodity | undefined
): StoreActiveCommodityAction => {
  return { type: ProfileActionTypes.STORE_ACTIVE_COMMODITY, payload: commodity };
};
